export const videoDownloadStatusColour = (x: VideoDownloadStatus) => {
  if (x === `initialising`) return `#e0e0e0`
  else if (x === `processing`) return `white`
  else if (x === `finished`) return `#5fdf20`
  else if (x === `expired`) return `orange`
  else if (x === `error`) return `red`
  else return `white`
}
